import { z } from "zod";

const date = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);
const ids = z
  .string()
  .regex(/^[0-9A-Za-z,]{1,1000}$/)
  .optional()
  .catch(undefined);
const int = (min: number, max: number) =>
  z.coerce.number().int().min(min).max(max).optional().catch(undefined);

/** Filtros das telas do BI histórico na URL (inválido vira undefined = padrão do servidor). */
export const abcSearch = z.object({
  from: date,
  to: date,
  channels: ids,
  statuses: ids,
  metric: z.enum(["revenue", "margin", "qty"]).optional().catch(undefined),
});
export const customersSearch = z.object({
  from: date,
  to: date,
  channels: ids,
  statuses: ids,
  activeDays: int(7, 365),
  riskDays: int(14, 730),
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional()
    .catch(undefined),
});
export const productsBiSearch = z.object({ salesDays: int(7, 365), idleDays: int(7, 730) });
